// @flow

import userInfoSpy from 'user-info-spy';

import DefaultController from './default';

import { apiStatuses, events } from '../dictionary';

import type { IController } from '../contracts';

const INFO_KEY_PHONE = 'smscheck.phone';
const INFO_KEY_QUOTATION = 'smscheck.quotation';
/* 
 * В калькуляторе каско ожидается заполнение соответствующих 
 * полей localstorage после успешной проверки телефона
*/
export default class KaskoController
	extends DefaultController
	implements IController {

	_handleVerifyResponse = ({ responseJSON: response }) => {
		if (!response || !response.Status) {
			const message = 'An error occurred while verifying SMS code';
			console.warn(message);
			throw new Error(message);
		}

		const isSuccessful = response.Status === apiStatuses.success;
		
		if (isSuccessful) {
			this._model.Phone && userInfoSpy.set(INFO_KEY_PHONE, this._model.Phone.toJS());
			this._model.toJS && userInfoSpy.set(INFO_KEY_QUOTATION, this._model.toJS());
			this.emit(events.confirmationPassed);
		} else {
			this._viewModel.Code.setError('Неверный код');
		}
	}
}